import { queryOptions, useMutation, useQuery } from '@tanstack/vue-query';
import { type AxiosError, type AxiosResponse } from 'axios';

import { useAuthStore } from '@/common/stores/auth';
import { axios } from '@/helpers/axios';
import { type RevokedShopResource,type ShopResource } from '@/types/laravel';

export function shopsQueryOptions() {
  return queryOptions({
    queryKey: ['member-shops'],
    queryFn: () => axios.get<ShopResource[]>('member-shops'),
    select: (data) => data.data,
  });
}

export function useShops() {
  const authStore = useAuthStore();

  return useQuery({
    ...shopsQueryOptions(),
    enabled: authStore.isUserLogged,
  });
}

export interface ShopSwitchFormData {
  shop_id: number
}

export function useShopSwitchMutation() {
  return useMutation<
    AxiosResponse<ShopResource>,
    AxiosError,
    ShopSwitchFormData
  >({
    mutationFn: data => axios.patch('shop/switch', data),
  });
}

export function revokedShopsQueryOptions() {
  return queryOptions({
    queryKey: ['oauth', 'check-all-revoked-tokens'],
    queryFn: () => axios.get<RevokedShopResource>('oauth/check-all-revoked-tokens'),
    select: (data) => data.data,
  });
}

export function useRevokedShops() {
  const authStore = useAuthStore();
  
  return useQuery({
    ...revokedShopsQueryOptions(),
    enabled: authStore.isUserLogged,
  });
}